import { useEffect, useState } from "react"

const useCountdown = (durationInSeconds: number) => {
  const [countdown, setCountdown] = useState<number>(durationInSeconds)
  const [intervalId, setIntervalId] = useState<any>(0)

  const startCountdown = () => {
    const newIntervalId = setInterval(() => {
      setCountdown((currentCountdown) => currentCountdown - 1)
    }, 1000)
    setIntervalId(newIntervalId)
  }

  const stopCountdown = () => {
    clearInterval(intervalId)
    setIntervalId(0)
    setCountdown(durationInSeconds)
  }

  useEffect(() => {
    if (countdown === 0) {
      stopCountdown()
    }
  }, [countdown])

  return {
    startCountdown,
    stopCountdown,
    countdown,
    minutes: Math.floor(countdown / 60),
    seconds: Math.floor(countdown % 60),
  }
}

export default useCountdown
